import { inject, Injectable } from '@angular/core';
import { QuestionAttemptHttpModel } from '@examdojo/question';
import { distinct, distinctUntilChanged, map, mergeMap } from 'rxjs';
import { QuestionAttemptRealtimeBaseService } from '@examdojo/question';
import { BatchGradingEffectService } from './batch-grading-effect.service';

@Injectable()
export class QuestionAttemptRealtimeChallengeService extends QuestionAttemptRealtimeBaseService {
  private readonly batchGradingEffect = inject(BatchGradingEffectService);

  protected override setupListeners() {
    return this.listenForAllAttemptsStatusChanges();
  }

  protected override handleGradedStatus(record: QuestionAttemptHttpModel) {
    if (this.questionAttemptQuery.isQuestionMultipleChoice(record.id)) {
      return this.questionAttemptService.synchronizePostGradingState(record);
    }

    this.batchGradingEffect.bufferGradedAttempt(record.id);
  }

  private listenForAllAttemptsStatusChanges() {
    return this.questionAttemptQuery.entities$.pipe(
      map((entities) => entities.map((entity) => entity.attempt.id)),
      distinctUntilChanged((prev, curr) => prev.length === curr.length && prev.every((id, i) => id === curr[i])),
      mergeMap((ids) => ids),
      distinct(),
      mergeMap((attemptId) => this.listenToAttemptStatusChanges(attemptId)),
    );
  }
}
